export const MESSAGE_AVATAR_SIZE = '300' as const;
export const MESSAGE_AVATAR_WIDTH_PX = 36;

export const MESSAGE_LAYOUT_GAP = '300' as const;
export const MESSAGE_LAYOUT_GAP_SPACE_KEY = `S${MESSAGE_LAYOUT_GAP}` as const;
